// import React, { useState } from 'react';
// import axios from 'axios';
// import * as XLSX from 'xlsx';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Swal from 'sweetalert2';

// const API_URL = process.env.REACT_APP_API;

// const ShowEntryNo = ({ fromDate, toDate, companyCode, yearCode }) => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');

//     const fetchShowEntryNo = async () => {
//         try {
//             setLoading(true);
//             setError('');
//             const response = await axios.get(`${API_URL}/ShowEntryNo-summary`, {
//                 params: {
//                     from_date: fromDate,
//                     to_date: toDate,
//                     Company_Code: companyCode,
//                     Year_Code: yearCode,
//                 },
//             });
//             if (response.data.length === 0) {
//                 Swal.fire({
//                     icon: 'error',
//                     title: 'Data Not Found.!',
//                     text: 'No ShowEntryNo data found for the selected date range.',
//                 });
//                 return;
//             }
//             setData(response.data);
//             openReportInNewTab(response.data);
//         } catch (err) {
//             setError('Failed to fetch data');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const openReportInNewTab = (reportData) => {
//         const newTab = window.open('', '_blank');
//         if (newTab) {
//             const reportHtml = `
//                 <html>
//                     <head>
//                         <title>Show Entry No Report</title>
//                         <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
//                         <style>
//                         body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
//                         h2 { text-align: center; margin-top: 0; }
//                         table { width: 80%; margin: 20px auto; border-collapse: collapse; }
//                         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//                         th { background-color: #f4f4f4; }
//                         .export-btn { 
//                             padding: 10px 20px; 
//                             font-size: 16px; 
//                             background-color: green; 
//                             color: white; 
//                             border: none; 
//                             cursor: pointer; 
//                             margin-top: 20px;
//                         }
//                         .total-row { background-color: yellow; font-weight: bold; }
//                     </style>
//                     </head>
//                     <body>
//                         <div class="container mt-4">
//                             <h3 class="text-center">Show Entry No Report</h3>
//                             <button class="export-btn" onclick="downloadCSV()">Export to CSV</button>
//                             <table class="table table-bordered">
//                                 <thead>
//                                     <tr>
//                                         <th style="text-align: center;">Nature of Document</th>
//                                         <th style="text-align: center;">Sr. No. From</th>
//                                         <th style="text-align: center;">Sr. No. To</th>
//                                         <th style="text-align: center;">Total Number</th>
//                                         <th style="text-align: center;">Cancelled</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                 ${reportData.map(row => `
//                                 <tr>
//                                     <td style="text-align: center;">${row["Nature"] || ''}</td>
//                                     <td style="text-align: center;">${row["Fromno"] || ''}</td>
//                                     <td style="text-align: center;">${row["Tono"] || ''}</td>
//                                     <td style="text-align: center;">${row["Total"] || ''}</td>
//                                     <td style="text-align: center;">${row["Cancel"] || 0}</td>
//                                 </tr>
//                             `).join('')}
//                                 </tbody>
//                             </table>
//                         </div>
//                         <script>
//                             function downloadCSV() {
//                                 const csvData = \`${JSON.stringify(reportData)}\`;
//                                 const parsedData = JSON.parse(csvData);
//                                 const columnOrder = ["Nature","Fromno","Tono","Total","Cancel"]
//                                 const ws = XLSX.utils.json_to_sheet(parsedData, { header: columnOrder, skipHeader: false });
//                                 const csv = XLSX.utils.sheet_to_csv(ws);
//                                 const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//                                 const link = document.createElement("a");
//                                 link.href = URL.createObjectURL(blob);
//                                 link.setAttribute("download", "ShowEntryNo.csv");
//                                 document.body.appendChild(link);
//                                 link.click();
//                                 document.body.removeChild(link);
//                             }
//                         </script>
//                         <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.9/xlsx.full.min.js"></script>
//                     </body>
//                 </html>
//             `;
//             newTab.document.write(reportHtml);
//             newTab.document.close();
//         } else {
//             alert("Please allow pop-ups for this site to view the report.");
//         }
//     };

//     return (
//         <div className="d-flex flex-column align-items-center" style={{ marginTop: '5px' }}>
//             <button className="btn btn-primary mb-3" onClick={fetchShowEntryNo} disabled={loading} style={{
//                 width: '20%',
//                 height: '60px',
//             }}>
//                 {loading ? 'Loading...' : 'ShowEntryNo'}
//             </button>
//             {error && <div className="alert alert-danger">{error}</div>}
//         </div>
//     );
// };

// export default ShowEntryNo;


import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API;

const ShowEntryNo = ({ fromDate, toDate, companyCode, yearCode }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchShowEntryNo = async () => {
        try {
            setLoading(true);
            setError('');

            const response = await axios.get(
                `${API_URL}/ShowEntryNo-summary`,
                {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        Company_Code: companyCode,
                        Year_Code: yearCode,
                    },
                }
            );

            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found.!',
                    text: 'No ShowEntryNo data found for the selected date range.',
                });
                return;
            }

            setData(response.data);
            openReportInNewTab(response.data);

        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const openReportInNewTab = (reportData) => {
        const newTab = window.open('', '_blank');

        if (!newTab) {
            alert("Please allow pop-ups for this site to view the report.");
            return;
        }

        const reportHtml = `
            <html>
                <head>
                    <title>Show Entry No Report</title>

                    <link rel="stylesheet"
                        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">

                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>

                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            padding: 20px;
                            text-align: center;
                        }

                        table {
                            width: 90%;
                            margin: 20px auto;
                            border-collapse: collapse;
                        }

                        th, td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: center;
                        }

                        th {
                            background-color: #f4f4f4;
                        }

                        .export-btn {
                            padding: 10px 20px;
                            font-size: 16px;
                            background-color: green;
                            color: white;
                            border: none;
                            cursor: pointer;
                            margin: 10px;
                        }
                    </style>
                </head>

                <body>
                    <div class="container mt-4">

                        <h3 class="text-center">
                            Show Entry No Report
                        </h3>

                        <button class="export-btn"
                            onclick="downloadCSV()">
                            Export to CSV
                        </button>

                        <button class="export-btn"
                            onclick="window.exportToPortalExcel()">
                            Export to Portal Excel
                        </button>

                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Nature of Document</th>
                                    <th>Sr. No. From</th>
                                    <th>Sr. No. To</th>
                                    <th>Total Number</th>
                                    <th>Cancelled</th>
                                </tr>
                            </thead>

                            <tbody>
                                ${reportData.map(row => `
                                    <tr>
                                        <td>${row["Nature"] || ''}</td>
                                        <td>${row["Fromno"] || ''}</td>
                                        <td>${row["Tono"] || ''}</td>
                                        <td>${row["Total"] || ''}</td>
                                        <td>${row["Cancel"] || 0}</td>
                                    </tr>
                                `).join('')}
                            </tbody>
                        </table>
                    </div>

                    <script>
                        function downloadCSV() {

                            const csvData =
                                \`${JSON.stringify(reportData)}\`;

                            const parsedData =
                                JSON.parse(csvData);

                            const columnOrder = [
                                "Nature",
                                "Fromno",
                                "Tono",
                                "Total",
                                "Cancel"
                            ];

                            const ws =
                                XLSX.utils.json_to_sheet(
                                    parsedData,
                                    {
                                        header: columnOrder,
                                        skipHeader: false
                                    }
                                );

                            const csv =
                                XLSX.utils.sheet_to_csv(ws);

                            const blob = new Blob(
                                [csv],
                                {
                                    type:
                                    "text/csv;charset=utf-8;"
                                }
                            );

                            const link =
                                document.createElement("a");

                            link.href =
                                URL.createObjectURL(blob);

                            link.setAttribute(
                                "download",
                                "ShowEntryNo.csv"
                            );

                            document.body.appendChild(link);

                            link.click();

                            document.body.removeChild(link);
                        }
                    </script>

                </body>
            </html>
        `;

        newTab.document.write(reportHtml);

        // =========================
        // EXPORT TO PORTAL EXCEL
        // =========================

        newTab.exportToPortalExcel = async function () {

            try {

                // Loader
                const loader =
                    newTab.document.createElement("div");

                loader.id = "reportLoader";

                loader.innerHTML = `
                    <div style="
                        position:fixed;
                        top:0;
                        left:0;
                        width:100%;
                        height:100%;
                        background:rgba(0,0,0,0.5);
                        display:flex;
                        justify-content:center;
                        align-items:center;
                        z-index:99999;
                        flex-direction:column;
                    ">
                        <div style="
                            border:6px solid #f3f3f3;
                            border-top:6px solid #3498db;
                            border-radius:50%;
                            width:50px;
                            height:50px;
                            animation:spin 1s linear infinite;
                        "></div>

                        <div style="
                            color:white;
                            margin-top:15px;
                            font-size:20px;
                            font-weight:bold;
                        ">
                            Downloading Excel...
                        </div>
                    </div>

                    <style>
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    </style>
                `;

                newTab.document.body.appendChild(loader);

                // API CALL
                const response = await axios.get(
                    `${API_URL}/CreateGSTR1Combined-summary`,
                    {
                        params: {
                            from_date: fromDate,
                            to_date: toDate,
                            Company_Code: companyCode,
                            Year_Code: yearCode,
                        },
                        responseType: "blob",
                    }
                );

                // Download File
                const url =
                    window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                const link =
                    newTab.document.createElement("a");

                link.href = url;

                link.download =
                    "CreateGSTR1Combined.xlsx";

                newTab.document.body.appendChild(link);

                link.click();

                link.remove();

            } catch (error) {

                console.error(error);

                alert("Failed to download excel");

            } finally {

                const loader =
                    newTab.document.getElementById(
                        "reportLoader"
                    );

                if (loader) loader.remove();
            }
        };

        newTab.document.close();
    };

    return (
        <div
            className="d-flex flex-column align-items-center"
            style={{ marginTop: '5px' }}
        >
            <button
                className="btn btn-primary mb-3"
                onClick={fetchShowEntryNo}
                disabled={loading}
                style={{
                    width: '20%',
                    height: '60px',
                }}
            >
                {loading ? 'Loading...' : 'ShowEntryNo'}
            </button>

            {error && (
                <div className="alert alert-danger">
                    {error}
                </div>
            )}
        </div>
    );
};

export default ShowEntryNo;
